import storage from './storage'
import translations from './translations'
import { MODES } from 'core/constants'
import { clearCache } from 'core/actions'

const URLS = {
  production: 'https://api.thedatingmessenger.com',
  dev: 'http://ccp-api.dev.starcoders.com',
  staging: 'https://api.staging.thedatingmessenger.com',
  test: 'https://api.ccp.test.msnebula.com',
}
const MEDIA_URLS = {
  production: 'https://media.thedatingmessenger.com/media/',
  staging: 'https://media.staging.thedatingmessenger.com/media/',
}
const WEBSOCKET_URLS = {
  production: 'wss://69x89kcmob.execute-api.eu-west-1.amazonaws.com/production/',
  staging: 'wss://4xv4ll07cb.execute-api.eu-west-1.amazonaws.com/staging/',
}
let wsUrl = location.hostname.match(/\.dp-core\.com$|^localhost$|^(www.dev|dev|www.staging|staging|local.staging|nuxt.staging)\./) ? WEBSOCKET_URLS.staging : WEBSOCKET_URLS.production
let url = location.hostname === 'localhost' ? URLS.dev : (location.hostname.match(/\.dp-core\.com$|^(www.dev|dev|www.staging|staging|local.staging|nuxt.staging)\./) ? URLS.staging : URLS.production)
let mediaUrl = location.hostname.match(/\.dp-core\.com$|^localhost$|^(www.dev|dev|www.staging|staging|local.staging|nuxt.staging)\./) ? MEDIA_URLS.staging : MEDIA_URLS.production
// Code inside this check is stripped off when not on localhost
if (process.env.NODE_ENV !== 'production') {
  url = URLS[storage.get('SERVER_ENV', 'staging')] || `${location.host}/api`
  mediaUrl = MEDIA_URLS[storage.get('SERVER_ENV', 'staging')] || `${location.host}/media`
  window.CCP_CONF = window.CCP_CONF || storage.get('WIDGET_USER', {})
}

export const chatListDefaultStyles = {
  modals: '#F8F8F8',
  textPrimary: '#494949',
  textSecondary: '#747272',
  textButtons: '#747272',
  cta: '#F5F5F5',
  sections: '#FFFFFF',
  primary: '#7FB802',
  background: '#F0F0F0',
  online: '#96D115',
  textTertiary: '#A8A8A8',
  inputsBorder: '#CBCACA',
  inputs: '#CBCACA',
};

export const siteColorsNames = [
  'modals',
  'textPrimary',
  'textSecondary',
  'textButtons',
  'cta',
  'sections',
  'primary',
  'background',
  'online',
  'textTertiary',
  'inputsBorder',
];

const CONFIG = {
  api: url,
  mediaUrl: mediaUrl,
  websocketConfig: {
      url: wsUrl,
  },
  identifier: null,
  userUid: null,
  userToken: null,
  safeMode: false,
  idleTimeout: 600000, // 10m
  mode: MODES.WIDGET, // widget | sidebar | vertical
  privateImagesNSFW: [],
  unlockedPrivateImages: [],
  unlockedVoiceMessages: [],
  hideCreditsCostForMobile: null,
  hooks: {
    onMount: () => {},
    onUnmount: () => {},
    onReady: () => {},
    onToggle: () => {},
    onMessageSend: () => {},
    onClickOutside: () => {},
    onRevealLocation: () => {},
    onRevealMessage: () => {},
    onBlockedMessage: () => {},
    onUploadPhotoRequest: () => {},
    onPurchaseFeaturedMembership: () => {},
    onMessageReceived: () => {},
    onOpenUpgradePopup: () => {},
  },
  actions: {
    clearCache: clearCache,
  },
  blackList: [],
  stickers: [],
  translations,
  urls: {
    upgrade: () => '/payment/upgrade',
    profile: profile => profile.profileUrl || '#',
    terms: '/terms',
    sticker: false,
    sound: false, // name => `https://widget.thedatingmessenger.com/widget/assets/sounds/${name}.mp3`,
    mobileIcon: false, // https://common.${CONFIG.siteDomain}/icons/${siteName}.svg,
    amupgrade: '/billing/upgradePassthrough',
  },
  features: {
    virtualHottie: +localStorage.ccpVirtualHottie || false,
    blockAfterInteraction: +localStorage.ccpBlockAfterInteraction || false,
    cssVars: +localStorage.ccpCssVars || false,
    canDelete: +localStorage.ccpCanDelete || false,
    useCats: +localStorage.ccpUseCats || false,
    fetchExtraFeatureSwitches: +localStorage.fetchExtraFeatureSwitches || false,
    intl: +localStorage.ccpIntl || false,
    emptyState: null,
    verticalToWidgetMobile: false,
    isCreditSite: false,
    hasFreeCredits: false,
    useMessagesInsteadOfCredits: false,
    creditsForSendingPhotos: null,
    creditsForLocationReveal: null,
  },
  styles: {
    main: '#488eeb',
    mainText: '#fff',

    conversation: '#fff',
    conversationText: '#000',

    sender: 'rgba(72, 142, 235, 0.2)',
    senderText: '#000',

    receiver: 'rgba(72, 142, 235, 0.4)',
    receiverText: '#000',

    send: '#7ed321',
    sendText: '#fff',

    chatUnread: '#C53133',
    chatUnreadText: '#fff',
  },
  ...(window.CCP_CONF || {}),
}

window.CONFIG = CONFIG

export default CONFIG

